const minxinForm = {
  methods: {
    /**
     * @description 根据名称与步骤值找到对应的值
     * @param {string} name  - 表单项名称
     */
    findField(name) {
      let fieldObj = this.data.find(item => item.name === name);
      return fieldObj;
    },
    /**
     * @description 赋值
     * @param {string} name - 表单项名称
     * @param {string} value  - 表单项值
     * @param {string} key  - 表单项的key
     */
    setFieldValue(name, value, key = "value") {
      this.$set(this.findField(name), key, value);
    },
    /**
     * @description  获取值
     * @param {string} name - 表单项名称
     * @param {string} key  - 表单项的key
     */
    getFieldValue(name, key = "value") {
      let obj = this.findField(name);
      return obj[key];
    },
    /**
     * @description 实时赋值
     */
    getData(index, value) {
      this.$set(this.data[index], "value", value);
    }
  }
};

export { minxinForm };
